import React from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentContainer, DocumentContent, DocumentText, DocumentTitle, DocumentUpdated } from 'Pages/help/subPages/privacyPolicy/style';
import { HELP_TERMS_TEST_ID } from 'Pages/help/testId';
import { SwrKeys } from 'Shared/services/swr/swrKeys';
import { useGetAgreementDocument } from 'Shared/services/userActivation/api/ucmApiService';

function TermsAndConditions (): JSX.Element {
  const {t}         = useTranslation('accountHelp');
  const { data }    = useGetAgreementDocument(SwrKeys.TermsAndConditions);
  const content     = data?.data?.contentHtml || '';
  let   lastUpdated = '';

  if (data?.data?.updatedAt) {
    const date = new Date(data.data.updatedAt);
    lastUpdated = date.toLocaleString('en-US', {
      dateStyle: 'long',
    });
  }

  return (
    <DocumentContainer data-testid={HELP_TERMS_TEST_ID}>
      <DocumentContent>
        <DocumentTitle>{t('TermsAndConditions--title')}</DocumentTitle>
        <DocumentUpdated>{t('TermsAndConditions--lastUpdated', {date: lastUpdated})}</DocumentUpdated>
        <DocumentText dangerouslySetInnerHTML = {{__html: content}} />
      </DocumentContent>
    </DocumentContainer>
  );
}

export default TermsAndConditions;
